import React from "react";
import ReactApexChart from "react-apexcharts";

interface BarChartProps {
  labels: string[];
  series: number[];
  colors: string[];
}

const BarChart: React.FC<BarChartProps> = ({ colors, labels, series }) => {
  const options: any = {
    chart: {
      type: "bar" as "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "60%",
        distributed: true,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#333"],
      },
    },
    xaxis: {
      categories: labels,
      title: {
        text: "R-man",
        style: {
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      title: {
        text: "Amount",
        style: {
          fontSize: "14px",
        },
      },
      labels: {
        formatter: function (val: number) {
          return val.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
        },
      },
    },
    colors: colors,
    grid: {
      show: true,
      borderColor: "#E7E7E7",
      strokeDashArray: 0,
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return val.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        },
      },
    },
    legend: {
      show: false,
    },
  };

  return (
    <div id="bar-chart">
      <ReactApexChart
        options={options}
        series={[{ name: "Amount", data: series }]}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default BarChart;
